import { type InjectedFormikProps } from "formik";

import { InternalUserActivationStatus } from "types/enum";

import { BTFormItem } from "commonComponents/btWrappers/BTForm/BTForm";
import { NotificationPreferencesHeader } from "commonComponents/entity/notificationPreferences/NotificationPreferencesHeader/NotificationPreferencesHeader";
import { NotificationPreferencesTableExpandable } from "commonComponents/entity/notificationPreferences/NotificationPreferencesTableExpandable";
import { PageSection } from "commonComponents/utilities/PageSection/PageSection";

import {
    type IInternalUserFormValues,
    type InternalUserEntity,
    type InternalUserTabKeys,
} from "entity/internalUser/InternalUserDetails/InternalUser.api.types";

interface IInternalUserNotificationsProps {
    internalUserDetails: InternalUserEntity;
    canEdit: boolean;
    onChangeActiveKey: (value: InternalUserTabKeys) => void;
    isActive: boolean;
    inEditMode: boolean;
}

export function InternalUserNotifications({
    internalUserDetails,
    canEdit,
    isActive,
    inEditMode,
    ...props
}: InjectedFormikProps<IInternalUserNotificationsProps, IInternalUserFormValues>) {
    const userCanLogin =
        isActive &&
        internalUserDetails.internalUser.userEnabled &&
        internalUserDetails.internalUser.activationStatus ===
            InternalUserActivationStatus.ActiveInviteAccepted;
    const disabled = (!canEdit && !userCanLogin) || !inEditMode;

    return (
        <PageSection title="Notifications">
            <BTFormItem>
                <NotificationPreferencesHeader />
            </BTFormItem>
            <NotificationPreferencesTableExpandable {...props} disabled={disabled} />
        </PageSection>
    );
}
